var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.425,
    height: 46.963,
    viewBox: "0 0 55.425 46.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3144",
    "data-name": "Group 3144",
    transform: "translate(-174.817 -20.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart-love-like",
    d: "M20.329,37.467,5.059,21.564A11.181,11.181,0,0,1,5.647,5.618,10.174,10.174,0,0,1,20.8,7.35l.609.845.609-.845a10.174,10.174,0,0,1,15.15-1.732,11.181,11.181,0,0,1,.588,15.946l-15.271,15.9A1.48,1.48,0,0,1,20.329,37.467Z",
    transform: "translate(188.43 19.008)",
    fill: "#fff",
    stroke: "#0a0707",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "heart-love-like-2",
    "data-name": "heart-love-like",
    d: "M24.014,44.4,5.674,25.3A13.429,13.429,0,0,1,6.38,6.145a12.219,12.219,0,0,1,18.2,2.08l.731,1.015.731-1.015a12.219,12.219,0,0,1,18.2-2.08A13.429,13.429,0,0,1,44.94,25.3L26.6,44.4A1.777,1.777,0,0,1,24.014,44.4Z",
    transform: "translate(172.817 23.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "heart-love-like-3",
    "data-name": "heart-love-like",
    d: "M20.329,37.467,5.059,21.564A11.181,11.181,0,0,1,5.647,5.618,10.174,10.174,0,0,1,20.8,7.35l.609.845.609-.845a10.174,10.174,0,0,1,15.15-1.732,11.181,11.181,0,0,1,.588,15.946l-15.271,15.9A1.48,1.48,0,0,1,20.329,37.467Z",
    transform: "translate(177.412 26.351)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatches);
export default __webpack_public_path__ + "static/media/matches.d0c47bf53370bfe27cff4b05f50d13e0.svg";
export { ForwardRef as ReactComponent };